import { Component, OnInit, ViewChild, ElementRef, Input, HostListener } from '@angular/core';
import { DonutGraphConfigurations } from './circle-line-graph-models';
import { TitleConfigurations, TitleLineConfigurations } from '../title/title.configurations';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { CircleLineChartComponent } from 'app/shared/charts/circle-line-chart/circle-line-chart.component';
import { TitleComponent } from '../title/title.component';

@Component({
  selector: 'kla-circle-line-graph',
  templateUrl: './circle-line-graph.component.html',
  styleUrls: ['./circle-line-graph.component.scss'],
  standalone: true,
  imports: [ CommonModule, CircleLineChartComponent, TitleComponent ]
})
export class CircleLineGraphComponent implements OnInit {
  @ViewChild('panel', {static: true})
  public panel: ElementRef;

  @Input()
  public config: {
    title: TitleConfigurations,
    chartId: string
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  public chartConfig: DonutGraphConfigurations;

  public showChart = false;

  public titleContainer: ElementRef;

  constructor(private http: KlaHttpService) {  }

  ngOnInit() {
    this.chartConfig = {
      id : '_' + Math.random().toString(36).substr(2, 9),
      width: 345,
      height: 388,
      thickness: 50,
      isVertical: false,
      data: null
    };
    this.findChartData();
  }

  private findChartData() {
    this.http.getChartData('kla-circle-line-chart', this.config.chartId).subscribe(
      (data) => {
        this.chartConfig.data = data;
        this.showChart = true;
        if (!this.chartConfig.data) {
          console.error('Please provide bar chart configurations');
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }
  private resize() {
    const rectangle = this.panel.nativeElement.getBoundingClientRect();
    this.chartConfig.isVertical = false;

    if (rectangle.width < 607) {
      this.chartConfig.width = 387;
    }
    if (rectangle.width > 607) {
      this.chartConfig.isVertical = true;
      this.chartConfig.width = 388;
    } else if (rectangle.width > 344 && rectangle.width < 388) {
      this.chartConfig.width = rectangle.width;
    } else if (rectangle.width < 345) {
      this.chartConfig.width = 345;
    }
  }
}
